var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.291 4.66499C15.5448 4.41115 15.9564 4.41115 16.2102 4.66499L19.9602 8.41499C20.214 8.66883 20.214 9.08039 19.9602 9.33423L16.2102 13.0842C15.9564 13.3381 15.5448 13.3381 15.291 13.0842C15.0371 12.8304 15.0371 12.4188 15.291 12.165L18.5813 8.87461L15.291 5.58423C15.0371 5.33039 15.0371 4.91883 15.291 4.66499Z",
    fill: "#1A181E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.87559 9.52656C7.88765 9.52656 6.94019 9.91902 6.24161 10.6176C5.54304 11.3162 5.15059 12.2636 5.15059 13.2516C5.15059 14.2395 5.54304 15.187 6.24161 15.8855C6.94019 16.5841 7.88765 16.9766 8.87559 16.9766H15.7506C16.1096 16.9766 16.4006 17.2676 16.4006 17.6266C16.4006 17.9855 16.1096 18.2766 15.7506 18.2766H8.87559C7.54287 18.2766 6.26474 17.7471 5.32237 16.8048C4.38 15.8624 3.85059 14.5843 3.85059 13.2516C3.85059 11.9188 4.38 10.6407 5.32237 9.69835C6.26474 8.75598 7.54287 8.22656 8.87559 8.22656H19.5006C19.8596 8.22656 20.1506 8.51758 20.1506 8.87656C20.1506 9.23555 19.8596 9.52656 19.5006 9.52656H8.87559Z",
    fill: "#1A181E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRight);
export default __webpack_public_path__ + "static/media/arrow-up-right.ce8f30088427ce9b4aaa77b3215ffe5e.svg";
export { ForwardRef as ReactComponent };